// test490
(490 && 0);
